import { render, staticRenderFns } from "./selectMajor.vue?vue&type=template&id=2a97a471&scoped=true"
import script from "./selectMajor.vue?vue&type=script&lang=js"
export * from "./selectMajor.vue?vue&type=script&lang=js"
import style0 from "./selectMajor.vue?vue&type=style&index=0&id=2a97a471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a97a471",
  null
  
)

export default component.exports